module.exports = __webpack_public_path__ + "img/25.290aefb5.jpg";